import { z } from 'zod';

export type BoundaryParseResult<T> =
  | Readonly<{ tag: 'valid'; value: T }>
  | Readonly<{ tag: 'missing' }>
  | Readonly<{ tag: 'invalid'; rawValue: string }>;

export const nonEmptyTrimmedStringSchema = z.string().trim().min(1);

export function parseSearchParam<T>(
  rawValue: string | null,
  schema: z.ZodType<T>,
): BoundaryParseResult<T> {
  if (rawValue === null) {
    return { tag: 'missing' };
  }

  const parsed = schema.safeParse(rawValue);
  if (parsed.success) {
    return { tag: 'valid', value: parsed.data };
  }

  return { tag: 'invalid', rawValue };
}

export function parseSearchParamOrNull<T>(
  rawValue: string | null,
  schema: z.ZodType<T>,
): T | null {
  const parsed = parseSearchParam(rawValue, schema);
  return parsed.tag === 'valid' ? parsed.value : null;
}

export function parseQueryParam<T>(
  params: URLSearchParams,
  key: string,
  schema: z.ZodType<T>,
): BoundaryParseResult<T> {
  return parseSearchParam(params.get(key), schema);
}

export function parseSessionStorageValue<T>(
  rawValue: string | null,
  schema: z.ZodType<T>,
): BoundaryParseResult<T> {
  return parseSearchParam(rawValue, schema);
}
